import { Link, useLocation } from "react-router-dom";
import { NAV_LINKS } from "@/data";

const COMPANY_LINKS = [
  { label: "About", to: "/about" },
  { label: "Privacy Policy", to: "/privacy" },
  { label: "Terms of Service", to: "/terms" },
];

export default function Footer() {
  const { pathname } = useLocation();
  const isHome = pathname === "/";
  const hrefFor = (hash) => (isHome ? hash : `/${hash}`);

  return (
    <footer data-testid="site-footer" className="bg-brand-ink text-brand-cream pt-24 md:pt-32 pb-10 mt-16 md:mt-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-10 pb-16 border-b border-brand-teal/40">
          <div className="md:col-span-5">
            <div className="font-mono text-xs uppercase tracking-[0.25em] text-brand-sage mb-4">Ready when you are</div>
            <a href={hrefFor("#book")} data-testid="footer-cta" className="font-display text-4xl md:text-6xl lg:text-7xl leading-none hover:text-brand-sage transition-colors duration-300">
              Let’s talk →
            </a>
          </div>
          <div className="md:col-span-2">
            <div className="font-mono text-xs uppercase tracking-[0.15em] text-brand-cream/50 mb-4">Explore</div>
            <ul className="space-y-2">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a href={hrefFor(l.href)} className="text-brand-cream/80 hover:text-brand-sage transition-colors">{l.label}</a>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-2">
            <div className="font-mono text-xs uppercase tracking-[0.15em] text-brand-cream/50 mb-4">Company</div>
            <ul className="space-y-2">
              {COMPANY_LINKS.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} data-testid={`footer-link-${l.to.slice(1)}`} className="text-brand-cream/80 hover:text-brand-sage transition-colors">{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-3">
            <div className="font-mono text-xs uppercase tracking-[0.15em] text-brand-cream/50 mb-4">Contact</div>
            <ul className="space-y-2 text-brand-cream/80">
              <li>hello@peachflowai.com</li>
            </ul>
          </div>
        </div>

        <div className="pt-10 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <span className="w-3 h-3 rounded-full bg-brand-apricot" />
            <span className="font-display text-2xl">PeachFlow AI</span>
          </div>
          <p className="font-mono text-xs uppercase tracking-[0.15em] text-brand-cream/50">
            © {new Date().getFullYear()} PeachFlow AI — Agents with a human touch
          </p>
        </div>
      </div>
    </footer>
  );
}
